import React from 'react'
import './index.scss'
import Product2, { IRankProdutModel } from '../../atoms/product2'
import Product3 from '../../atoms/product3'
import classnames from 'classnames'
import RowProduct from '../../atoms/rowProduct/index'
import Product1 from '../../atoms/product1/index'
interface IProductListProps {
  productRow: number
  products: (IRankProdutModel | any)[]
  className?: string
}
const ProductList = (props) => {
  const { config, clickTo, id, pid } = props
  const { productRow, products, className } = config
  let Tproduct
  if (productRow === 'row') {
    Tproduct = RowProduct
  } else if (productRow === 1) {
    Tproduct = Product1
  } else if (productRow === 2) {
    Tproduct = Product2
  } else {
    Tproduct = Product3
  }
  const classes = classnames(
    productRow === 'row' ? 'lego_rowProductList' : 'lego_rankingProductsList',
    className
  )
  const Tclass = productRow === 'row' ? 'rowProduct' : `grid_col_${productRow}`
  let productsList = products ? [...products] : []
  if (productRow === 3 && products && products.length % 3 === 2) {
    productsList.push({ sizeSeat: true })
  }
  if (productRow !== 3) {
    productsList = (products && products.filter((item) => !item.sizeSeat)) || []
  }
  return (
    <div className={classes}>
      {productsList.length > 0 &&
        productsList.map((item: IRankProdutModel | any, index: number) => {
          return (
            <Tproduct
              className={Tclass}
              index={index}
              productInfo={item}
              key={item?.product?.id}
              clickTo={clickTo}
              pid={id}
              meta={config.meta ? config.meta[item?.product?.id] : {}}
            ></Tproduct>
          )
        })}
    </div>
  )
}

export default ProductList
